export default "__VITE_ASSET__BrPBXhbN__"